// extracted by mini-css-extract-plugin
export default {"ratingContent":"Ratings_ratingContent__IyxNi","ratingNumber":"Ratings_ratingNumber__OJggj"};